/* Keep Horizon's rendered cart line indices honest.

   Horizon identifies a cart line by its POSITION, not by its key. Liquid bakes
   that position into the markup at render time:

     on:click="/onLineItemRemove/{{ item.index | plus: 1 }}"     the bin button
     data-cart-line="{{ line_index | plus: 1 }}"                 the qty stepper

   assets/component.js reads the on: attribute at CLICK time, inside a document
   level listener, so a position that was correct when the page rendered is
   simply wrong if the cart has changed since. And it does change: hk-free-kit
   auto adds the Free Starter Kit a few hundred ms after boot, Shopify puts that
   line first, and every rendered index shifts by one.

   The visible symptom, reported 8 Aug and reproduced: you bin your bottle, the
   row you clicked animates away (Horizon removes it optimistically), the server
   actually deletes line 1 which is now the free kit, the section re render puts
   your bottle back about half a second later, and you have to bin it twice.
   Shopify's own response confirmed it: items_removed was the Free Starter Kit.

   Fix: rewrite both indices from the row's data-key, which is stable, against
   the live cart. Done on pointerdown and mousedown, which always precede click,
   so it lands regardless of which listener registered first.

   This never mutates the cart. It only corrects numbers already in the DOM.
   ES5 only, single install, a throw here must never reach the cart. */
(function () {
  "use strict";
  if (window.__hkLines) return;
  window.__hkLines = true;
  /* Comments do not survive Shopify's minifier. This is how a live check proves
     which build is being served. */
  window.HK_LINES_VER = "2026-08-08a";

  if (!window.fetch || !window.Promise || !document.querySelectorAll) return;

  /* Shared cart read. Six scripts each ask for /cart.js after every cart change,
     and that burst is what earns the 429s. One read per 300ms serves them all;
     each caller gets its own clone of the same response. */
  (function () {
    var last = null, at = 0, origFetch = window.fetch;
    var CART = /\/cart\.js(\?|$)/;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var method = (init && init.method) || (input && input.method) || "GET";
      if (CART.test(url) && String(method).toUpperCase() === "GET") {
        var now = Date.now();
        if (last && now - at < 300) return last.then(function (r) { return r.clone(); });
        at = now;
        last = origFetch.apply(this, arguments);
        return last.then(function (r) { return r.clone(); });
      }
      return origFetch.apply(this, arguments);
    };
  })();

  var keys = [];           /* line item keys, in true cart order */
  var fetching = false;
  var lastFetch = 0;

  function readCart() {
    /* Cart reads are cheap but automated bursts earn a 429 on this store, so
       never run two at once and never more than one every 400ms. */
    var now = new Date().getTime();
    if (fetching || now - lastFetch < 400) return;
    fetching = true;
    lastFetch = now;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        fetching = false;
        if (!cart || !cart.items) return;
        var next = [];
        for (var i = 0; i < cart.items.length; i++) next.push(cart.items[i].key);
        keys = next;
        resync();
      })
      .catch(function () { fetching = false; });
  }

  function lineFor(row) {
    var key = row.getAttribute("data-key");
    if (!key) return 0;
    for (var i = 0; i < keys.length; i++) if (keys[i] === key) return i + 1;
    return 0;   /* not in the cart we know about: leave the markup alone */
  }

  /* Correct every rendered index that disagrees with the live cart. Returns how
     many it changed, which is what the live check reads. */
  function resync() {
    if (!keys.length) return 0;
    var rows, fixed = 0;
    try { rows = document.querySelectorAll("cart-items-component [data-key]"); }
    catch (e) { return 0; }

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var line = lineFor(row);
      if (!line) continue;

      var btn = null;
      /* The attribute selector needs the colon escaped, and old Safari throws on
         a bad selector rather than returning null, so it is guarded. */
      try { btn = row.querySelector('[on\\:click^="/onLineItemRemove/"]'); } catch (e) {}
      if (btn) {
        var want = "/onLineItemRemove/" + line;
        if (btn.getAttribute("on:click") !== want) {
          btn.setAttribute("on:click", want);
          fixed++;
        }
      }

      var steppers = row.querySelectorAll("[data-cart-line]");
      for (var j = 0; j < steppers.length; j++) {
        if (steppers[j].getAttribute("data-cart-line") !== String(line)) {
          steppers[j].setAttribute("data-cart-line", String(line));
          fixed++;
        }
      }
    }
    if (fixed) window.HK_LINES_FIXED = (window.HK_LINES_FIXED || 0) + fixed;
    return fixed;
  }

  /* Just in time. pointerdown and mousedown both fire before click, so the
     attribute is already correct by the time component.js reads it. Uses the
     cached cart only, because this has to be synchronous. */
  function beforeClick(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest("cart-items-component")) return;
      resync();
      readCart();   /* refresh for next time, does not block this click */
    } catch (err) {}
  }
  document.addEventListener("pointerdown", beforeClick, true);
  document.addEventListener("mousedown", beforeClick, true);

  /* Anything that changes the cart invalidates the indices. */
  document.addEventListener("cart:update", function () { setTimeout(readCart, 120); });
  document.addEventListener("hk:kit-added", function () { setTimeout(readCart, 120); });

  function boot() { readCart(); setTimeout(readCart, 1400); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.HK_LINES = { resync: resync, keys: function () { return keys.slice(); } };
})();
